import * as React from 'react';
export const naverpaySvg = React.forwardRef(function naverpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8ZM4.016 6a2.097 2.097 0 1 0 0 4.194 2.097 2.097 0 0 0 0-4.194Zm4.115.965a.94.94 0 0 0-.635.233v-.192h-.481V9.71h.503v-.824c.17.14.371.217.613.217.577 0 1.028-.47 1.028-1.07 0-.6-.451-1.07-1.028-1.07Zm5.457.042-.583 1.329-.66-1.33h-.507l.935 1.845-.386.86h.492l1.201-2.705h-.492Zm-3.148-.042c-.577 0-1.029.47-1.029 1.07 0 .599.452 1.069 1.029 1.069a.94.94 0 0 0 .634-.235v.193h.482V7.006h-.482v.192a.94.94 0 0 0-.634-.233Zm-6.805.147.732 1.054V7.112h.635v1.971h-.605l-.732-1.055v1.055H3.03v-1.97h.605Zm4.434.24c.358 0 .63.295.63.682 0 .388-.27.683-.63.683-.358 0-.629-.295-.629-.683 0-.387.27-.681.63-.681Zm2.432 0c.359 0 .629.295.629.682 0 .387-.27.682-.629.682s-.63-.294-.63-.682c0-.387.272-.682.63-.682Z',
    }),
  );
});
naverpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var naverpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'naverpay',
  svg: naverpaySvg,
};
